export default "__VITE_ASSET__93cb8aa9__"